import React, { useState } from "react";
import { Pizza, Bike, Layers3 } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import EstatisticasProducao from "./Producao";
import EstatisticasEntrega from "./Entrega";
import EstatisticasMontagem from "./Montagem";

const Estatisticas: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "producoes" | "montagens" | "entregas"
  >("producoes");

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <PageHeader
        title="Estatísticas"
        description="Visualize dados e métricas detalhadas do sistema"
      />

      <div className="mt-6">
        <nav
          className="flex w-full max-w-full divide-x divide-neutral-200 overflow-x-auto overscroll-x-contain rounded-lg border border-neutral-200 shadow-sm [-ms-overflow-style:none] [scrollbar-width:none] sm:w-fit sm:divide-x-0 sm:overflow-visible"
          aria-label="Seções de estatísticas"
        >
          <button
            type="button"
            onClick={() => setActiveTab("producoes")}
            className={`flex min-w-0 flex-1 basis-0 items-center justify-center gap-1.5 px-2 py-3 text-center text-xs font-medium transition-colors sm:flex-initial sm:basis-auto sm:justify-start sm:gap-2 sm:px-6 sm:text-sm ${
              activeTab === "producoes"
                ? "bg-primary text-white"
                : "bg-neutral-50 text-neutral-600 hover:bg-neutral-100 hover:text-neutral-800"
            }`}
          >
            <Pizza size={16} className="shrink-0" />
            <span className="min-w-0 leading-tight">
              <span className="hidden sm:inline">Estatísticas de </span>
              Produções
            </span>
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("montagens")}
            className={`flex min-w-0 flex-1 basis-0 items-center justify-center gap-1.5 px-2 py-3 text-center text-xs font-medium transition-colors sm:flex-initial sm:basis-auto sm:justify-start sm:gap-2 sm:px-6 sm:text-sm ${
              activeTab === "montagens"
                ? "bg-primary text-white"
                : "bg-neutral-50 text-neutral-600 hover:bg-neutral-100 hover:text-neutral-800"
            }`}
          >
            <Layers3 size={16} className="shrink-0" />
            <span className="min-w-0 leading-tight">
              <span className="hidden sm:inline">Estatísticas de </span>
              Montagens
            </span>
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("entregas")}
            className={`flex min-w-0 flex-1 basis-0 items-center justify-center gap-1.5 px-2 py-3 text-center text-xs font-medium transition-colors sm:flex-initial sm:basis-auto sm:justify-start sm:gap-2 sm:px-6 sm:text-sm ${
              activeTab === "entregas"
                ? "bg-primary text-white"
                : "bg-neutral-50 text-neutral-600 hover:bg-neutral-100 hover:text-neutral-800"
            }`}
          >
            <Bike size={16} className="shrink-0" />
            <span className="min-w-0 leading-tight">
              <span className="hidden sm:inline">Estatísticas de </span>
              Entregas
            </span>
          </button>
        </nav>

        <div className="mt-6">
          {activeTab === "producoes" && <EstatisticasProducao />}
          {activeTab === "montagens" && <EstatisticasMontagem />}
          {activeTab === "entregas" && <EstatisticasEntrega />}
        </div>
      </div>
    </div>
  );
};

export default Estatisticas;
